import { createPersistedState } from 'pinia-plugin-persistedstate';

export default defineNuxtPlugin({
  name: 'pinia-persist',
  setup({ $pinia }) {
    if (!$pinia) return
    // Guard for client-only storage
    if (typeof window === 'undefined') return
    $pinia.use(createPersistedState({
      storage: localStorage
    }))
  }
})
